"use strict";

(($) => {
  // DOMContentLoadedで初期化
  document.addEventListener("DOMContentLoaded", (event) => {
    initSmoothScroll(80);
    initYubinbango();
    $(".js-modal-btn").modalVideo();
  }, {
    once: true
  });

  // loadイベントで初期化
  window.addEventListener("load", (event) => {
  }, {
    once: true
  });


  // yubinbango.jsの初期化
  function initYubinbango() {
    $('.h-adr').append('<span class="p-country-name" style="display:none;">Japan</span>');
    $('.js-postal-code-container input').addClass('p-postal-code').attr('inputmode', 'numeric').on('change', (event) => {
      // 全角英数字記号を半角に変換
      const REGEX = /[Ａ-Ｚａ-ｚ０-９！＂＃＄％＆＇（）＊＋，－．／：；＜＝＞？＠［＼］＾＿｀｛｜｝]/g;
      const $input = $(event.currentTarget);
      let str = $input.val();

      str = str.replace(REGEX, (s) => {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      })
        .replace(/[‐－―−]/g, '-') // ハイフンなど
        .replace(/[～〜]/g, '~') // チルダ
        .replace(/　/g, ' ') // スペース
        .trim();

      $input.val(str);
    });
    $('.js-address-container input').addClass('p-region p-locality p-street-address p-extended-address');
  }

  // 設定とユーティリティ
  const RM = window.matchMedia?.("(prefers-reduced-motion: reduce)") || { matches: false };
  const PC_BP = window.VIEWPORT_CONFIG?.PC_BREAKPOINT ?? 768; // フォールバック
  const PC_MQ = window.matchMedia?.(`(min-width: ${PC_BP}px)`) || { matches: true };

  function isPC() { return !!PC_MQ.matches; }
  function isMobile() { return !PC_MQ.matches; }

  // 汎用デバウンス
  function debounce(fn, wait = 150) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(null, args), wait);
    };
  }

  // initSmoothScroll
  function initSmoothScroll(defaultOffset = 0) {
    $(document).on("click", 'a[href*="#"]:not(".-no_smooth_scroll")', (event) => {
      // a要素取得
      const $a = $(event.currentTarget);

      // ユーザーの意図を尊重（修飾キー、別タブ）
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if ($a.attr("target") === "_blank") return;

      // href と URL解析
      const href = $a.attr("href");
      if (!href) return;
      const url = new URL(href, location.href);

      // オリジン/パスチェック（同一ページのみスムスク）
      if (url.origin !== location.origin) return;

      const currentPath = normalizePath(location.pathname);
      const targetPath = normalizePath(url.pathname);
      if (currentPath !== targetPath) return;

      // スムスク対象のIDを決定
      const id = url.hash;
      const target = id && id !== "#" ? id : document.documentElement;

      // 個別オフセット（data-offset）優先
      const linkOffset = Number($a.data("offset"));
      const offset = Number.isFinite(linkOffset) ? linkOffset : defaultOffset;

      // デフォルト動作を止めてスムスク/ジャンプ
      event.preventDefault();

      if (RM.matches) {
        // 動きを控えるユーザー設定：即時移動
        jumpTo(target, offset);
      } else {
        smoothScrollTo(target, offset);
      }
    });
  }

  // ジャンプ移動（A11y対応）
  function jumpTo(target, offset = 0) {
    const $target = $(target);
    if (!$target.length) return;
    const y = $target.offset().top - offset;
    window.scrollTo(0, y);
    focusTarget($target);
  }

  // スムーススクロール（A11y対応）
  function smoothScrollTo(target, offset = 0) {
    const $target = $(target);
    if (!$target.length) return;

    const start = $target.offset().top - offset;
    moveTo(start, 500);

    function moveTo(position, duration) {
      $.when(
        $("html, body").stop().animate({ scrollTop: position }, duration, "swing")
      ).done(() => {
        const newPos = $target.offset().top - offset;
        if (Math.abs(newPos - position) > 1) {
          moveTo(newPos, Math.max(duration - 100, 100));
        } else {
          focusTarget($target); // 最終到達時にフォーカス
        }
      });
    }
  }

  // フォーカス移動の補助（スクリーンリーダー配慮）
  function focusTarget($el) {
    const el = $el.get(0);
    if (!el) return;
    const hadTabindex = el.hasAttribute("tabindex");
    if (!hadTabindex) el.setAttribute("tabindex", "-1");
    el.focus({ preventScroll: true });
    if (!hadTabindex) el.addEventListener("blur", () => el.removeAttribute("tabindex"), { once: true });
  }

  // 正規表現のキャッシュ
  const normalizePathRegex =
    /\/index\.(html|php|htm|asp|aspx|cgi|pl|jsp|cfm|shtml)$/;

  // indexファイルをルート `/` に統一 + 末尾スラッシュの正規化
  function normalizePath(path) {
    return path
      .replace(normalizePathRegex, "/")
      .replace(/\/+$/, "")
      .replace(/^\/?/, "/");
  }
})(jQuery);
